import { createFormContext } from "@mantine/form";
import { Asserts } from "yup";
import perguntaSchema from "../../schema/pergunta-schema";

type FormInputs = Asserts<typeof perguntaSchema>;

const [PerguntaFormProvider] = createFormContext<FormInputs>();

export { PerguntaFormProvider };
